const pillars = [
  {
    n: "01",
    title: "Professionalism",
    body: "Disciplined posture, dress, and demeanor that mirrors your brand and audience.",
  },
  {
    n: "02",
    title: "Discretion",
    body: "Quiet presence. Your operations, principals, and guests remain private.",
  },
  {
    n: "03",
    title: "Elite Appearance",
    body: "Tailored, suited agents that elevate the room — not draw the eye.",
  },
  {
    n: "04",
    title: "De-escalation",
    body: "Resolution by skill and presence first. Force only when no alternative exists.",
  },
  {
    n: "05",
    title: "Visible Deterrence",
    body: "A composed, prepared presence that quietly removes the prospect of incident.",
  },
  {
    n: "06",
    title: "Tailored Strategy",
    body: "Every engagement is shaped around your environment, schedule, and people.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 sm:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl reveal mb-16">
          <span className="overline">Why The Bridge Collective</span>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
            <span className="cursor-mark">Serious organizations</span>
            <br />
            trust serious protection.
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed max-w-xl">
            We are engaged by clients who expect their security partner to
            disappear into the background — until the moment composure and
            capability are required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {pillars.map((p, i) => (
            <div
              key={p.n}
              data-testid={`why-pillar-${i}`}
              className="reveal bg-[#050505] p-8 sm:p-10 hover:bg-[#0c0c0c] transition-colors"
            >
              <div className="font-display text-[#1A5C40] text-sm tracking-[0.3em] mb-6">
                {p.n}
              </div>
              <h3 className="font-display text-xl text-white font-medium">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
